import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const useVersionCheck = (): void => {
  const location = useLocation();
  // This won't be set for local development, so no need to check for NODE_ENV
  const initialVersion = useRef<string | null>(null);

  useEffect(() => {
    const metaTag = document.querySelector('meta[name="build-id"]');
    initialVersion.current = metaTag?.getAttribute('content') ?? null;
  }, []);

  useEffect(() => {
    if (!initialVersion.current) return;

    const check = async () => {
      try {
        const res = await fetch(`/?t=${Date.now()}`, { cache: 'no-store' });
        const html = await res.text();
        const match = html.match(/<meta name="build-id" content="([^"]+)"/);
        if (match && match[1] !== initialVersion.current) {
          window.location.reload();
        }
      } catch {
        // network error, skip
      }
    };

    check();
  }, [location.pathname]);
};
